<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.30</b> - Introducting... hero affinities!</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        HERO AFFINITIES: Now your level 30+ heroes can spend ability points on "Affinity"
        upgrades, giving them bonus damage or damage reduction against specific hero
        classes or monster types. Find the Affinities interface in the lower left of the
        Edit Abilities screen!
      </li>
      <li>
        Fixed a serious bug causing Caverns mobs abilities always to be level 0. So,
        you're going to find mobs a lot more dangerous at the depths you're already at.
        Since this is likely to cause some players to have to restart Caverns from the
        first level, I'm giving everyone
        <span style="color: cyan">1,000 Pixie Dust</span> to make up for it.
      </li>
      <li>
        Balance - increase Burning Hands damage scaling:<code
          >65 + L*(Le/5 + Ma/7 + De/10)</code
        >
        --> <code>65 + L*(Le/3 + Ma/5 + De/7)</code>
      </li>
    </ul>
  </div>
</template>
